//# sourceMappingURL=label_translations.mjs.map
/// <reference types="./label_translations.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $page from "../../../data_types/data/page.mjs";
import * as $translate from "../../../data_types/data/translate.mjs";
import * as $language from "../../../data_types/data/translate/language.mjs";
import * as $iso639 from "../../../data_types/data/translate/language/iso639.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $route from "../../data/route.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function kind(route) {
  if (route instanceof $route.Administration) {
    let $ = route[0];
    if ($ instanceof $route.SectionTranslations) {
      return new $translate.Section();
    } else {
      return new $translate.Choice();
    }
  } else {
    return new $translate.Choice();
  }
}

function kind_segment(store) {
  return $translate.translation_target_to_string(kind(store.route));
}

export function fetch(page_index, search, language_filter, sort) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["translations", kind_segment(store)]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.query(
            _pipe$1,
            "page_index",
            $int.to_string(page_index),
          );
          let _pipe$3 = $ask.query(
            _pipe$2,
            "page_size",
            $int.to_string($page.default_page_size),
          );
          let _pipe$4 = $ask.query(_pipe$3, "sort", sort);
          let _block;
          if (search instanceof Some) {
            let search$1 = search[0];
            _block = (_capture) => {
              return $ask.query(_capture, "search", search$1);
            };
          } else {
            _block = $function.identity;
          }
          let _pipe$5 = _block(_pipe$4);
          let _block$1;
          if (language_filter instanceof Some) {
            let language = language_filter[0];
            _block$1 = (_capture) => {
              return $ask.query(
                _capture,
                "language",
                $iso639.to_string(language),
              );
            };
          } else {
            _block$1 = $function.identity;
          }
          let _pipe$6 = _block$1(_pipe$5);
          let _pipe$7 = $ask.expect(
            _pipe$6,
            $page.page_decoder($decode.list($translate.translation_decoder())),
          );
          let _pipe$8 = $ask.on_success(
            _pipe$7,
            (pagination) => {
              let _pipe$8 = pagination;
              let _pipe$9 = new $msg.ApiReturnedLabelTranslations(_pipe$8);
              let _pipe$10 = new $msg.LabelTranslations(_pipe$9);
              return dispatch(_pipe$10);
            },
          );
          return $ask.run(_pipe$8);
        },
      );
    },
  );
}

export function delete$(id, version) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["translations", id, $int.to_string(version)]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Delete());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (_) => {
              let _pipe$3 = new $msg.ApiDeletedTranslation(id, version);
              let _pipe$4 = new $msg.LabelTranslations(_pipe$3);
              return dispatch(_pipe$4);
            },
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}

/**
 * Removes every language of one label at once, identified by its digest
 * (`Translation.target_id`).
 */
export function delete_label(target_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["translations", kind_segment(store), "label", target_id]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Delete());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.field(
              "deleted",
              $decode.int,
              (deleted) => { return $decode.success(deleted); },
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (deleted) => {
              let _pipe$4 = new $msg.ApiDeletedLabelTranslations(
                target_id,
                deleted,
              );
              let _pipe$5 = new $msg.LabelTranslations(_pipe$4);
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$4);
        },
      );
    },
  );
}

/**
 * The admin view asks for a typed confirmation before it dispatches this.
 */
export function delete_all() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["translations", kind_segment(store)]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Delete());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.field(
              "deleted",
              $decode.int,
              (deleted) => { return $decode.success(deleted); },
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (deleted) => {
              let _pipe$4 = new $msg.ApiDeletedAllLabelTranslations(deleted);
              let _pipe$5 = new $msg.LabelTranslations(_pipe$4);
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$4);
        },
      );
    },
  );
}
